import { render, staticRenderFns } from "./FcrSummary.vue?vue&type=template&id=36355f23&scoped=true"
import script from "./FcrSummary.vue?vue&type=script&lang=js"
export * from "./FcrSummary.vue?vue&type=script&lang=js"
import style0 from "./FcrSummary.vue?vue&type=style&index=0&id=36355f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36355f23",
  null
  
)

export default component.exports